import { SharedSortOrder } from "./shared-sort-order.model";

export class SharedPagedRequest {
  /**
   * The number of the page to request (first page is 1)
   * @NB If you want to request all datas (without pagination) set this value at -1
   */
  page?: number;
  /**
   * The maximum number of elements in one page
   */
  count?: number;
  /**
   * Say if the request will do request with AND (if true) or OR (if false or null) operator
   */
  matchAny?: boolean;
  /**
   * Say if the string filter data are in contains or strict (must be equals to the filter attribute) mode
   */
  textMatchMode: 'STRICT'|'CONTAINS';
  /**
   * The sort configuration
   */
  sort?: SharedSortOrder[];
}